import { TextField } from "@mui/material"
import SecurityIcon from '@mui/icons-material/Security';
import { txt } from "../../services/translation";


export default function Pin({value, onChange, length, error}){

    const l = length || 6;

    return <TextField
        label={txt('pinLabel', {length: l})}
        value={value || ''}
        onChange={onChange}
        error={error ? true : false}
        helperText={error || ''}
        required
        InputProps={{
            inputProps: {
                minLength: l,
                maxLength: l,
                pattern: `[0-9]{${l}}`
            },
            endAdornment: <SecurityIcon color={error ? 'error' : 'action'} />
        }}
        size='small'
    />
}